import styled from "styled-components";

export const AppCheckBoxDropDownContainer = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
`
export const DropDownLabelAndErrorContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`
export const TextLabel = styled.label`
`
export const TextLabelSpan = styled.span`
color: red;
`